// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html,
body {
    min-height: 100vh;
    max-width: 100vw;
    margin: 0;
    padding: 0;
    font-family: "Nunito Sans", sans-serif;
}

input::placeholder,
button {
    font-family: "Nunito Sans", sans-serif;
}

a {
    text-decoration: none;
    color: black;
}

img {
    max-width: 100%;
    height: auto;
}

button {
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
}


`, "",{"version":3,"sources":["webpack://./src/styles.scss","webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;IAGI,SAAA;IACA,UAAA;IACA,sBAAA;ACCJ;;ADEA;;IAEI,iBAAA;IACA,gBAAA;IACA,SAAA;IACA,UAAA;IACA,sCAAA;ACCJ;;ADEA;;IAEI,sCAAA;ACCJ;;ADEA;IACI,qBAAA;IACA,YAAA;ACCJ;;ADEA;IACI,eAAA;IACA,YAAA;ACCJ;;ADEA;IACI,YAAA;IACA,gBAAA;IACA,UAAA;IACA,eAAA;ACCJ","sourcesContent":["*,\r\n*::before,\r\n*::after {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\nhtml,\r\nbody {\r\n    min-height: 100vh;\r\n    max-width: 100vw;\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: \"Nunito Sans\", sans-serif !important;\r\n}\r\n\r\ninput::placeholder,\r\ninput,\r\nbutton {\r\n    font-family: \"Nunito Sans\", sans-serif !important;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n    color: #090b0e;\r\n}\r\n\r\nimg {\r\n    max-width: 100%;\r\n    height: auto;\r\n}\r\n\r\nbutton {\r\n    border: none;\r\n    background: none;\r\n    padding: 0;\r\n    cursor: pointer;\r\n}\r\n","*,\r\n*::before,\r\n*::after {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\nhtml,\r\nbody {\r\n    min-height: 100vh;\r\n    max-width: 100vw;\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: \"Nunito Sans\", sans-serif;\r\n}\r\n\r\ninput::placeholder,\r\nbutton {\r\n    font-family: \"Nunito Sans\", sans-serif;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n    color: black;\r\n}\r\n\r\nimg {\r\n    max-width: 100%;\r\n    height: auto;\r\n}\r\n\r\nbutton {\r\n    border: none;\r\n    background: none;\r\n    padding: 0;\r\n    cursor: pointer;\r\n}\r\n\r\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
